'use client';
import { IconDefinition, faFaceLaughBeam, faUserGroupSimple, faHandHoldingHeart } from '@fortawesome/pro-light-svg-icons';

interface CompanyValues {
  icon: IconDefinition;
  title: string;
  description: string;
}
export const ourValues: CompanyValues[] = [
  {
    icon: faFaceLaughBeam,
    title: 'Empatia',
    description: 'Entendemos e cuidamos das pessoas com atenção e carinho.',
  },
  {
    icon: faUserGroupSimple,
    title: 'Respeito',
    description: 'Valorizamos cada pessoa, promovendo inclusão e igualdade.',
  },
  {
    icon: faHandHoldingHeart,
    title: 'Dignidade',
    description: 'Oferecemos atendimento justo e humano a todos, sem exceção.',
  },
];
